import { getWindow } from "@faire/web--source/common/getWindow";
import getAdsBait from "@faire/web-api--source/api/ads/ad/get";
import { trackAdsAdblockDetectorFireForAllView } from "@faire/web-api--source/events/ads/view/adblockDetectorFireForAll";
import { trackAdsAdblockDetectorUserBlockedDomView } from "@faire/web-api--source/events/ads/view/adblockDetectorUserBlockedDom";
import { trackAdsAdblockDetectorUserBlockedResourceView } from "@faire/web-api--source/events/ads/view/adblockDetectorUserBlockedResource";
import { useEffect, useRef } from "react";
import { doesUserHaveAdblock } from "./doesUserHaveAdblock";
import { insertAdblockBait } from "./insertAdblockBait";
export var useAdblockDetector = function() {
    var userToken = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    useEffect(function() {
        insertAdblockBait();
    }, []);
    useNestedRAF(function() {
        trackAdsAdblockDetectorFireForAllView(userToken);
        if (doesUserHaveAdblock()) {
            trackAdsAdblockDetectorUserBlockedDomView(userToken);
        }
        getAdsBait().catch(function() {
            trackAdsAdblockDetectorUserBlockedResourceView(userToken);
        });
    });
};
var useNestedRAF = function(callback) {
    var callbackRef = useRef(callback);
    callbackRef.current = callback;
    useEffect(function() {
        var childRef = null;
        var parentRef = getWindow().requestAnimationFrame(function() {
            childRef = getWindow().requestAnimationFrame(function() {
                callbackRef.current();
            });
        });
        return function() {
            getWindow().cancelAnimationFrame(parentRef);
            if (childRef !== null) {
                getWindow().cancelAnimationFrame(childRef);
            }
        };
    }, []);
};
